import { toastr } from 'react-redux-toastr'
import branditRails from '../../../../api/brandit_rails'
import {
  setShipFromAddressesAction,
  setShipFromAddressAction,
  setShipFromAddressesStatusAction,
  setShipFromAddressesErrorsAction,
  clearShipFromAddressesErrorsAction
} from './shipFromAddresses.actions'

export const fetchShipFromAddresses = () => async dispatch => {
  try {
    dispatch(setShipFromAddressesStatusAction('loading'))
    dispatch(clearShipFromAddressesErrorsAction())

    const { data } = await branditRails.get('/ship_from_addresses')

    // Convert array to object with id as key
    const addressesById = data.reduce((acc, address) => {
      acc[address.id] = address
      return acc
    }, {})

    dispatch(setShipFromAddressesAction(addressesById))
    dispatch(setShipFromAddressesStatusAction('succeeded'))

    return data
  } catch (err) {
    const errorMessage = err.response?.data?.message || err.message
    dispatch(setShipFromAddressesErrorsAction({ message: errorMessage }))
    dispatch(setShipFromAddressesStatusAction('failed'))
    toastr.error('Error', errorMessage)
    throw err
  }
}

export const createShipFromAddress = formData => async dispatch => {
  try {
    dispatch(setShipFromAddressesStatusAction('loading'))
    dispatch(clearShipFromAddressesErrorsAction())

    const { data } = await branditRails.post('/ship_from_addresses', formData)

    dispatch(setShipFromAddressAction(data))
    dispatch(setShipFromAddressesStatusAction('succeeded'))
    toastr.success('Success', 'Ship from address created successfully!')

    return data
  } catch (err) {
    const errorMessage = err.response?.data?.message || err.message
    dispatch(setShipFromAddressesErrorsAction({ message: errorMessage }))
    dispatch(setShipFromAddressesStatusAction('failed'))
    toastr.error('Error', errorMessage)
    throw err
  }
}

export const editShipFromAddress = (id, formData) => async dispatch => {
  try {
    dispatch(setShipFromAddressesStatusAction('loading'))
    dispatch(clearShipFromAddressesErrorsAction())

    const { data } = await branditRails.patch(`/ship_from_addresses/${id}`, formData)

    dispatch(setShipFromAddressAction(data))
    dispatch(setShipFromAddressesStatusAction('succeeded'))
    toastr.success('Success', 'Ship from address updated successfully!')

    return data
  } catch (err) {
    const errorMessage = err.response?.data?.message || err.message
    dispatch(setShipFromAddressesErrorsAction({ message: errorMessage }))
    dispatch(setShipFromAddressesStatusAction('failed'))
    toastr.error('Error', errorMessage)
    throw err
  }
}

export const deleteShipFromAddress = id => async dispatch => {
  try {
    dispatch(setShipFromAddressesStatusAction('loading'))
    dispatch(clearShipFromAddressesErrorsAction())

    await branditRails.delete(`/ship_from_addresses/${id}`)

    // Refresh addresses after deletion
    await dispatch(fetchShipFromAddresses())

    dispatch(setShipFromAddressesStatusAction('succeeded'))
    toastr.success('Success', 'Ship from address deleted successfully!')
  } catch (err) {
    const errorMessage = err.response?.data?.message || err.message
    dispatch(setShipFromAddressesErrorsAction({ message: errorMessage }))
    dispatch(setShipFromAddressesStatusAction('failed'))
    toastr.error('Error', errorMessage)
    throw err
  }
}

export const updateSubOrderShipFromAddress = (subOrderId, shipFromAddressId) => async dispatch => {
  try {
    dispatch(setShipFromAddressesStatusAction('loading'))
    dispatch(clearShipFromAddressesErrorsAction())

    const { data } = await branditRails.patch(`/sub_orders/${subOrderId}/ship_from_address`, {
      ship_from_address_id: shipFromAddressId
    })

    dispatch(setShipFromAddressesStatusAction('succeeded'))
    toastr.success('Success', 'Sub order shipping address updated successfully!')

    return data
  } catch (err) {
    const errorMessage = err.response?.data?.message || err.message
    dispatch(setShipFromAddressesErrorsAction({ message: errorMessage }))
    dispatch(setShipFromAddressesStatusAction('failed'))
    toastr.error('Error', errorMessage)
    throw err
  }
}
